import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ICertinomis} from './certinomis';
import {API_URL, HTTP_OPTION, HTTP_OPTION_PARAMS} from '../app-config.service';


@Injectable({
  providedIn: 'root'
})

export class CertinomisApiService {
  constructor(private readonly http: HttpClient
  ) {

  }


  getVersion(): Observable<ICertinomis[]> {

    return this.http.get<ICertinomis[]>(API_URL + '/version', HTTP_OPTION);
  }

  getAllCertificate(): Observable<ICertinomis[]> {

    return this.http.get<ICertinomis[]>(API_URL + '/certificate/', HTTP_OPTION);
  }



  CreateAdmin(obj: any): Observable<any> {

    // const body = new FormData();
    const body: FormData = new FormData();

    // let body = new URLSearchParams();
    if (typeof obj.username === 'string') {
      body.append('username', obj.username);
    }
    if (typeof obj.mail === 'string') {
      body.append('mail', obj.mail);
    }


    if (typeof obj.first_name === 'string') {
      body.append('first_name', obj.first_name);
    }
    if (typeof obj.last_name === 'string') {
      body.append('last_name', obj.last_name);
    }

    if (typeof obj.role_id === 'number') {
      body.append('role_id', String(obj.role_id));
    }

    if (obj.organism_id && typeof obj.organism_id === 'object') {
      body.append('organism_id', obj.organism_id.id);
    }

    if (obj.portal_id && typeof obj.portal_id === 'object') {
      body.append('portal_id', obj.portal_id.id);
    }


    return this.http.post<any>(API_URL + '/tenderlink/admin', body, {
      reportProgress: true,
      observe: 'events'
    });
  }


  UpdateAdmin(obj: any): Observable<any> {

    // const body = new FormData();
    const body: FormData = new FormData();

    // let body = new URLSearchParams();
    if (typeof obj.username === 'string') {
      body.append('username', obj.username);
    }
    if (typeof obj.mail === 'string') {
      body.append('mail', obj.mail);
    }

    if (typeof obj.password === 'string') {
      body.append('password', obj.password);
    }


    return this.http.post<any>(API_URL + '/tenderlink/admin/_update/' + String(obj.adminId), body, {
      reportProgress: true,
      observe: 'events'
    });
  }


  LockAdmin(adminId: number): Observable<any> {

    return this.http.post<any>(API_URL + '/tenderlink/admin/_lock/' + String(adminId), {});
  }

  UnlockAdmin(adminId: number): Observable<any> {

    return this.http.post<any>(API_URL + '/tenderlink/admin/_unlock/' + String(adminId), {});
  }


  ForgotPasswordAdmin(email: string): Observable<any> {

    return this.http.get<any>(API_URL + '/tenderlink/admin/_forgetPassword?email=' + email, HTTP_OPTION);
  }

}

